import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/version/index.js
// module id = null
// module chunks = 